<script setup lang="ts">
import PrivacyListBlock from '~/components/privacyPolicy/privacyListBlock/PrivacyListBlock.vue';
import PrivacyTextBlock from '~/components/privacyPolicy/privacyTextBlock/PrivacyTextBlock.vue';

type PrivacyTextBlockData = {
    type: 'text';
    value: string;
};

type PrivacyListBlockData = {
    type: 'list';
    items: string[];
};

type PrivacyBlock = PrivacyTextBlockData | PrivacyListBlockData;

defineProps<{
    content: {
        title: string;
        isBordered?: boolean;
        blocks: PrivacyBlock[];
    }[];
}>();

const privacyBlockComponents = {
    text: PrivacyTextBlock,
    list: PrivacyListBlock,
};

const getPrivacyBlockComponent = (block: PrivacyBlock) => {
    return privacyBlockComponents[block.type];
};

const getPrivacyBlockProps = (block: PrivacyBlock) => {
    if (block.type === 'text') {
        return {
            text: block.value,
        };
    }

    return {
        items: block.items,
    };
};
</script>

<template>
    <div
        v-for="item in content"
        :key="item.title"
        class="privacy-item privacy__item"
        :class="{ 'privacy-item--is-bordered': item.isBordered }"
    >
        <div class="privacy-item__title">
            <span class="privacy-item__caption">
                {{ item.title }}
            </span>
        </div>

        <div class="privacy-item__content">
            <component
                :is="getPrivacyBlockComponent(block)"
                v-for="(block, index) in item.blocks"
                :key="index"
                v-bind="getPrivacyBlockProps(block)"
            />
        </div>
    </div>
</template>
